export default __webpack_public_path__ + "static/media/bg_87672501.f8c32b3b.webp";